import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/ContextSelector/context-selector';
import { css } from '@patternfly/react-styles';
import SearchIcon from '@patternfly/react-icons/dist/js/icons/search-icon';
import { ContextSelectorToggle } from './ContextSelectorToggle';
import { ContextSelectorMenuList } from './ContextSelectorMenuList';
import { ContextSelectorContext } from './contextSelectorConstants';
import { Button, ButtonVariant } from '../Button';
import { TextInput } from '../TextInput';
import { InputGroup } from '../InputGroup';
import { KEY_CODES } from '../../helpers/constants';
import { FocusTrap } from '../../helpers'; // seed for the aria-labelledby ID

var currentId = 0;
var newId = currentId++;
export var ContextSelector =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContextSelector, _React$Component);

  function ContextSelector() {
    var _this;

    _classCallCheck(this, ContextSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContextSelector).apply(this, arguments));
    _this.parentRef = React.createRef();

    _this.onEnterPressed = function (event) {
      if (event.charCode === KEY_CODES.ENTER) {
        _this.props.onSearchButtonClick();
      }
    };

    return _this;
  }

  _createClass(ContextSelector, [{
    key: "render",
    value: function render() {
      var toggleId = "pf-context-selector-toggle-id-".concat(newId);
      var screenReaderLabelId = "pf-context-selector-label-id-".concat(newId);
      var searchButtonId = "pf-context-selector-search-button-id-".concat(newId);

      var _a = this.props,
          children = _a.children,
          className = _a.className,
          isOpen = _a.isOpen,
          onToggle = _a.onToggle,
          onSelect = _a.onSelect,
          screenReaderLabel = _a.screenReaderLabel,
          toggleText = _a.toggleText,
          searchButtonAriaLabel = _a.searchButtonAriaLabel,
          searchInputValue = _a.searchInputValue,
          onSearchInputChange = _a.onSearchInputChange,
          searchInputPlaceholder = _a.searchInputPlaceholder,
          onSearchButtonClick = _a.onSearchButtonClick,
          props = __rest(_a, ["children", "className", "isOpen", "onToggle", "onSelect", "screenReaderLabel", "toggleText", "searchButtonAriaLabel", "searchInputValue", "onSearchInputChange", "searchInputPlaceholder", "onSearchButtonClick"]);

      return React.createElement("div", Object.assign({
        className: css(styles.contextSelector, isOpen && styles.modifiers.expanded, className),
        ref: this.parentRef
      }, props), screenReaderLabel && React.createElement("span", {
        id: screenReaderLabelId,
        hidden: true
      }, screenReaderLabel), React.createElement(ContextSelectorToggle, {
        onToggle: onToggle,
        isOpen: isOpen,
        toggleText: toggleText,
        id: toggleId,
        parentRef: this.parentRef.current,
        "aria-labelledby": "".concat(screenReaderLabelId, " ").concat(toggleId)
      }), isOpen && React.createElement("div", {
        className: css(styles.contextSelectorMenu)
      }, isOpen && React.createElement(FocusTrap, {
        focusTrapOptions: {
          clickOutsideDeactivates: true
        }
      }, React.createElement("div", {
        className: css(styles.contextSelectorMenuSearch)
      }, React.createElement(InputGroup, null, React.createElement(TextInput, {
        value: searchInputValue,
        type: "search",
        placeholder: searchInputPlaceholder,
        onChange: onSearchInputChange,
        onKeyPress: this.onEnterPressed,
        "aria-labelledby": searchButtonId
      }), React.createElement(Button, {
        variant: ButtonVariant.control,
        "aria-label": searchButtonAriaLabel,
        id: searchButtonId,
        onClick: onSearchButtonClick
      }, React.createElement(SearchIcon, {
        "aria-hidden": "true"
      })))), React.createElement(ContextSelectorContext.Provider, {
        value: {
          onSelect: onSelect
        }
      }, React.createElement(ContextSelectorMenuList, {
        isOpen: isOpen
      }, children)))));
    }
  }]);

  return ContextSelector;
}(React.Component);
ContextSelector.defaultProps = {
  children: null,
  className: '',
  isOpen: false,
  onToggle: function onToggle() {
    return undefined;
  },
  onSelect: function onSelect() {
    return undefined;
  },
  screenReaderLabel: '',
  toggleText: '',
  searchButtonAriaLabel: 'Search menu items',
  searchInputValue: '',
  onSearchInputChange: function onSearchInputChange() {
    return undefined;
  },
  searchInputPlaceholder: 'Search',
  onSearchButtonClick: function onSearchButtonClick() {
    return undefined;
  }
};